<script>
const Ring = () => import("../ringReport");
import {sortedKeys} from "./data"

export default {
    name: "TopList",
    props: {
        data2: {
            type: Object,
            default: () => ({})
        },
        pieData: {
            type: Array,
            default: () => ([])
        },
        showPie: {
            type: Boolean,
            default: true
        }
    },
    components: {
        Ring
    },
}
</script>

<template>
    <div >
        <div class="pie" v-for="(item, index) in pieData" :key="index">
            <div style="display: flex; flex-wrap: wrap;justify-content: space-between">
                <div class="part1" v-for="(item2, idx2) in item" :key="idx2"
                     :style="'width:' + (100 / item.length) + '%'">
                    <div v-if="item2.data">
                        <div class="line1" v-if="index === 0">{{ item2.key }}</div>
                        <div v-if="showPie && index === 0" class="pie-wrapper">
                            <div style="width: 110px; height: 110px; flex-shrink: 0">
                                <Ring :data="data2[item2.key]" v-if="data2 && data2[item2.key]"></Ring>
                            </div>
                            <div class="legend-wrapper">
                                <div>
                                    <div
                                        class="legend-dot"
                                        style="background: #59CF7A;"
                                    ></div>
                                    <div class="legend-text">未预警KRI</div>
                                </div>
                                <div>
                                    <div
                                        class="legend-dot"
                                        style="background: #EA6257;"
                                    ></div>
                                    <div class="legend-text">预警KRI</div>
                                </div>
                                <div class="littleword">
                                    核心风险已预警：{{data2[item2.key]['核心风险已预警']}}
                                </div>
                                <div class="littleword">
                                    发展风险已预警：{{data2[item2.key]['发展风险已预警']}}
                                </div>
                                <div class="littleword">
                                    运营风险已预警：{{data2[item2.key]['运营风险已预警']}}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="line2">{{ item2.data.name }}</div>
                            <div v-for="(item3, index3) in item2.data.data" :key="index3">
                                <div class="line3">{{ index3 }}</div>
                                <ul class="line4">
                                    <li :class="{item:true,status99red:item4['当前预警状态']==99,status1yellow:item4['当前预警状态'] == 1}" v-for="(item4, index4) in item3">
                                        {{ index4 }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
.littleword{
    padding-left:12px;
    font-size:11px;
}
.status99red{
    color:#e16a6a;
}
.status1yellow{
    color:#e4cc88;
}
.pie {
    .pie-wrapper {
        display: flex;
        align-items: center;

        .legend-wrapper {
            margin-left: 20px;

            & > div {
                display: flex;
                align-items: center;
            }

            .legend-dot {
                width: 8px;
                height: 8px;
                border-radius: 2px;
            }

            .legend-text {
                padding-left: 4px;
                font-size: 12px;
            }
        }
    }
}
.part1 {
    //display: flex;
    // display: inline-block;
    justify-content: space-between;
    padding-left: 1vw;
    margin-bottom: 2vw;

    .line1 {
        font-weight: 700;
        white-space: nowrap;
        font-size: 20px;
    }

    .line2 {
        white-space: nowrap;
        padding: 2px 12px;
        text-align: center;
        background-color: #ccc;
        display: inline-block;
        border-radius: 6px;
        margin-top: 6px;
        margin-bottom: 6px;
        font-size: 18px;
    }

    .line3 {
        font-weight: 600;
        font-size: 16px;
    }

    .line4 {
        font-size: 14px;
        padding-left: 18px;
    }


}
</style>